import { render, staticRenderFns } from "./VideoCaller.vue?vue&type=template&id=65385f06&"
import script from "./VideoCaller.vue?vue&type=script&lang=js&"
export * from "./VideoCaller.vue?vue&type=script&lang=js&"
import style0 from "./VideoCaller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports